import { CircularProgress } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import GenericButton from "@/components/forms/inputs/button/genericButton";
import styles from "@/components/userAdministration/workerCsvImportRunningPanel.module.css";

interface Props {
  startedAt?: string;
  onClose: () => void;
}

export default function WorkerCsvImportRunningPanel({
  startedAt,
  onClose,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.panel} role="status">
      <CircularProgress size={40} className={styles.spinner} />
      <h3 className={styles.title}>{t("worker_csv_import_running_title")}</h3>
      <p className={styles.text}>{t("worker_csv_import_running_infotext")}</p>
      {startedAt && (
        <span className={styles.startedAt}>
          {t("worker_csv_import_running_since", {
            time: dayjs(startedAt).format("HH:mm"),
          })}
        </span>
      )}
      <p className={styles.hint}>
        <InfoOutlinedIcon fontSize="small" />
        {t("create_document_task_waiting_infotext")}
      </p>
      <GenericButton variant="outlined" onClick={onClose}>
        {t("close")}
      </GenericButton>
    </div>
  );
}
